import { UNDISCLOSED_EVENT_VALUE } from '../../../../common/support/utils/eo_constants';

export default function appendNumericMetricWithEventData(
  currentValue: number | null | undefined,
  increment: number,
  metricParser?: (arg: number) => number
): number | null {
  let parsedMetricValue: number | null = UNDISCLOSED_EVENT_VALUE;

  if ((currentValue !== UNDISCLOSED_EVENT_VALUE && currentValue !== undefined) || increment !== UNDISCLOSED_EVENT_VALUE) {
    const rawMetricValue = (currentValue || 0) + (+increment || 0);
    parsedMetricValue = metricParser ? metricParser(rawMetricValue) : rawMetricValue;
  }

  return parsedMetricValue;
}
